import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'

export const RawFoodBenefitsRoot = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '$accent-white',
  width: '100%',
})

export const Wrapper = styled('div', {
  maxWidth: '$max',
  padding: '$6 0',

  '@bp2': {
    paddingTop: '$13',
    paddingBottom: '160px',
  },

  '@bp3': {
    padding: '$13',
  },
})

export const BenefitList = styled('ul', {
  width: '100%',
  maxWidth: '416px',
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignSelf: 'center',
  gap: '$3',

  '@bp2': {
    $$mobileCircleWidth: '960px',
    minWidth: '$$mobileCircleWidth',
    minHeight: '$$mobileCircleWidth',
    position: 'relative',
  },
})

export const IconCircle = styled('div', {
  size: '$10',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$tertiary-200',
  border: '2px solid $primary-700',
  borderRadius: '$round',

  '@bp2': {
    size: '$13',
  },
})

export const BenefitsCircle = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',

  [`& ${BenefitList} ${Text}`]: {
    width: '168px',
  },

  '@bp2': {
    [`& ${BenefitList} ${Stack}:nth-of-type(3) ${Text}`]: {
      width: '128px',
    },

    [`& ${Stack}`]: {
      position: 'absolute',

      '&:nth-of-type(1)': {},
      '&:nth-of-type(2)': {
        top: '15%',
        right: '1%',
        transform: 'translateX(-25%)',
      },
      '&:nth-of-type(3)': {
        top: '50%',
        right: '0',
        transform: 'translateY(-30%)',
      },
      '&:nth-of-type(4)': {
        bottom: '15%',
        right: '1%',
        transform: 'translate(-25%, 50%)',
      },
      '&:nth-of-type(5)': {
        bottom: '0',
        transform: 'translateY(40%)',
      },
      '&:nth-of-type(6)': {
        bottom: '15%',
        left: '3%',
        transform: 'translate(25%, 50%)',
      },
      '&:nth-of-type(7)': {
        top: '50%',
        left: 0,
        transform: 'translate(-15%, -25%)',
      },
      '&:nth-of-type(8)': {
        top: '15%',
        left: '3%',
        transform: 'translateX(25%)',
      },
    },
  },
})

export const MobileBubble = styled('img', {
  position: 'absolute',
  bottom: '0',
  left: '50%',
  transform: 'translate(-50%)',
  maxHeight: '50%',

  '@bp1': {
    maxHeight: '60%',
  },

  '@bp2': {
    display: 'none',
  },
})

export const DesktopBubble = styled('img', {
  display: 'none',

  '@bp2': {
    display: 'block',
    maxWidth: '875px',
    position: 'absolute',
    top: '$4',
  },
})

export const DottedCircle = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'block',
    border: '5px dotted $primary-500',
    position: 'absolute',
    top: '$7',
    left: '$7',
    size: '858px',
    borderRadius: '$round',
  },
})

export const Description = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  padding: '$6',

  '@bp2': {
    gap: '$3',
    width: '450px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -45%)',
  },

  '& div': {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    position: 'relative',
  },
})
